export default "__VITE_ASSET__CRMdOQt2__"